export class Plantilla {
    plantillaid: number = 0;
    descripcion: string = "";
    departamentoid: number[] = [];
    puestoid: number[] = [];
    evaluadorid: number = 0;
    gradoid: number[] = [];
    evaluadorcopiarid: string = "";
    materiacopiaid: string = "";
    materiacopiaselectid: string = "";
    gradocopiarid: string = "";
    puestocopiarid: string = "";
    nivelid: number[] = [];
    materiaid: number[] = [];
    tipoplantillaid: number = 0;
    activo: boolean = true;

    constructor(init?: Partial<Plantilla>) {
        Object.assign(this, init);
    }
}